import React, { useEffect, useState, useRef } from "react";
import { Button, Modal, Form, Table, Image } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Select from "react-select";
import LinearProgress from "@mui/material/LinearProgress";

const statusOption = [
    { value: 0, label: "pending" },
    { value: 1, label: "Approve" },
    { value: 2, label: "Reject" },
    { value: 3, label: "Spam" },
];

const EditComment = ({ showModal, handleClose, fetchAllComment, comment }) => {
    const formRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const resetFormFields = (resetForm, setValues, initialValues) => {
        resetForm();
        setValues({
            ...initialValues,
        });
    };

    const initialValues = {
        pk_com_key: comment && comment.pk_com_key ? comment.pk_com_key : "",
        ac_name: comment && comment.ac_name ? comment.ac_name : "",
        comment: comment && comment.comment ? comment.comment : "",
        com_status: comment && comment.com_status ? comment.com_status : "",
        com_name: comment && comment.com_name ? comment.com_name : "",
        updated_by: sessionStorage.getItem("pk_user_key"),
    };


    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            toast.dismiss();
            setIsSubmitting(true);

            try {
                const response = await axios.post(
                    `${BASE_URL}API/apicall`,
                    {
                        security_key: security_key,
                        mode: "updateComment",
                        ...formValues,
                    },
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                const output = response.data;
                if (output === 1) {
                    handleClose();
                    fetchAllComment();
                    toast.success("Updated successfully!", { autoClose: 3000 });
                } else {
                    toast.error("Oops! Something went wrong.", { autoClose: 3000 });
                }
            } catch (error) {
                toast.error("Error occurred during submission.", { autoClose: 3000 });
            } finally {
                setIsSubmitting(false);
            }
        },
    });

    return (
        <>
            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Comment</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={formik.handleSubmit} ref={formRef}>
                        <Form.Group className="mb-3">
                            <Form.Label>Article Name <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                name="ac_name"
                                value={formik.values.ac_name}
                                readOnly
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>User <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                name="com_name"
                                value={formik.values.com_name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Text <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                as="textarea"
                                name="comment"
                                value={formik.values.comment}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Status <span className="text-danger">*</span></Form.Label>
                            <Select
                                options={statusOption}
                                id="com_status"
                                name="com_status"
                                value={statusOption.filter((option) => formik.values.com_status == option.value)}
                                onChange={(selectedOption) => {
                                    formik.setFieldValue("com_status", selectedOption.value);
                                }}
                                onBlur={formik.handleBlur}
                            />
                        </Form.Group>
                        <Modal.Footer>
                            <Button variant="dark" type="submit" disabled={isSubmitting}>
                                Save
                                {isSubmitting && <LinearProgress />}
                            </Button>
                            <Button variant="outline-secondary" className="ms-2" onClick={handleClose}>
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default EditComment;